export default __webpack_public_path__ + "static/media/Help.abc936b9.svg";